import './style.scss';

function switchLight(e) {
	e.preventDefault();
	document.body.classList.remove("theme-dark");
	document.body.classList.add("theme-light");
	document.cookie = "theme=light; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT";
}

function switchDark(e) {
	e.preventDefault();
	document.body.classList.remove("theme-light");
	document.body.classList.add("theme-dark");
	document.cookie = "theme=dark; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT";
}

// Add event listeners to theme toggle buttons
document.addEventListener('DOMContentLoaded', function() {
	const toggleButtons = document.querySelectorAll('.theme-toggle');
	
	toggleButtons.forEach(button => {
		button.addEventListener('click', function(e) {
			const theme = this.getAttribute('data-theme') || this.value;
			
			if (theme === 'dark') {
				switchDark(e);
			} else if (theme === 'light') {
				switchLight(e);
			}
		});
	});
});